<template>
  <div class="layers">
    <h2>Warstwy</h2>
    <el-button class="clear" type="danger" @click="clearObjects">
        Usuń wszystkie elementy
    </el-button>
    <draggable :list="layers" @end="handleLayersChange">
        <div
            class="layer"
            :class="{ 'disabled': !layer.selectable, 'locked': layer.lockMovementX, 'excluded':layer.excludeFromSVG }"
            :key="index"
            v-for="(layer, index) in layers"
            @click="handleObjectClick(layer)"
        >
            <span class="icon material-symbols-outlined">
                drag_indicator
            </span>
            {{ getObjectType(layer) }}
            <span class="actions">
                <span class="material-symbols-outlined" @click="handleMovingObject(layer)">
                    {{ layer.lockMovementX ? 'lock' : 'no_encryption' }}
                </span>
                <span class="material-symbols-outlined" @click="handleSelectionObject(layer)">
                    {{ layer.selectable ? 'back_hand' : 'do_not_touch' }}
                </span>
                <span class="material-symbols-outlined" @click="handleToggleVisibilityObject(layer)">
                    {{ layer.excludeFromSVG ? 'visibility_off' : 'visibility' }}
                </span>
                <span class="material-symbols-outlined" @click="handleRemoveObject(layer)">
                    delete
                </span>
            </span>
        </div>
    </draggable>
  </div>
</template>

<script>
import Editor from '../../classes/Editor'
import Draggable from 'vuedraggable'

export default {
    data() {
      return {
          layers: [],
          sortLayers: []
      };
    },
    mounted() {
        // Load layers on load
        this.layers = Editor.getObjects()

        // Update layers on canvas rerender
        Editor.addCallback('after:render', () => this.layers = Editor.getObjects())
    },
    methods: {
        clearObjects() {
            Editor.canvas.remove(...Editor.canvas.getObjects());
        },
        handleObjectClick(object) {
            Editor.canvas.setActiveObject(object)
            Editor.canvas.renderAll()
        },
        handleLayersChange() {
            this.layers.reverse().forEach((object, index) => object.moveTo(index))
        },
        getObjectType(object) {
            return Editor.getObjectName(object)
        },
        handleMovingObject(object) {
            object.lockMovementX = !object.lockMovementX
            object.lockMovementY = !object.lockMovementY
        },
        handleSelectionObject(object) {
            object.selectable = !object.selectable
            object.evented = object.selectable
            Editor.canvas.fire('object:modified');
        },
        handleToggleVisibilityObject(object) {
            object.excludeFromSVG = !object.excludeFromSVG
        },
        handleRemoveObject(object) {
            this.$confirm('Czy na pewno usunąć ten element?', 'Uwaga!', {
                type: 'warning',
                confirmButtonText: 'Tak',
            }).then(() => Editor.canvas.remove(object))
        },
    },
    components: {
        Draggable
    }
}
</script>

<style lang="less">
    .layer {
        padding: 10px 16px 10px 5px;
        background: #f4f6fc;
        color: black;
        display: flex;
        cursor: pointer;
        font-size: 13px;
        border-radius: 5px;
        display: flex;
        align-items: center;

        &.locked {
            background: #f4f6fc;
            color: black;
        }

        &.disabled {
            opacity: .5;
        }

        &.excluded {
            background: #F56C6C;
            color: #fff;
        }
    }
    .icon {
        font-size: 16px;
        margin-right: 5px;
    }
    .layer + .layer {
        margin-top: 7px;
    }
    .clear {
        width: 100%;
        margin-bottom: 20px;
    }
    .actions {
      margin-left: auto;

      span {
        font-size: 16px;
        cursor: pointer;

        + span {
              margin-left: 5px;
          }
      }
  }
</style>